module.exports = __webpack_public_path__ + "images/application/i-edit-295ecf2d.svg";